import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetVerificationResponse } from './types';
import { PostErrorResponse } from '../post';

type VerificationType = 'email' | 'mobile';

export const getVerification = async (type: VerificationType = 'email', lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/verify/${type}?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetVerificationResponse>;
		return res.json().then(errorResponse => {
			throw errorResponse as PostErrorResponse
		});
	})
	.catch((error) => {
		console.error('Profile request error: ', error);
		throw error;
	});
};
